export default "__VITE_ASSET__NT7etJgB__"